package one.healthium.common.mapper

class ColorMapper {

    // just copy of native Android method Color.parseColor()
    fun parseColor(colorString: String): Long? {
        var colorLong = if (colorString[0] == '#') {
            // Use a long to avoid rollovers on #ffXXXXXX
            colorString.substring(1).toLongOrNull(16)
        } else {
            colorString.toLongOrNull(16)
        }
        if (colorLong != null) {
            if (colorString.length == 6 || colorString.length == 7) {
                // Set the alpha value
                colorLong = colorLong or 0x00000000ff000000L
            } else if (colorString.length != 9) {
                return null
            }
        }
        return colorLong
    }

}